import { render, staticRenderFns } from "./InventoryResponsiveCard.vue?vue&type=template&id=535542c6"
import script from "./InventoryResponsiveCard.vue?vue&type=script&lang=js"
export * from "./InventoryResponsiveCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports